import React from "react";
import { Tooltip } from "@mui/material";

export const Title = ({ item }) => {
  return (
    <Tooltip title={item.heading || "-"}>
      <div
        style={{
          fontWeight: 400
        }}
      >
        {item.heading || "-"}
      </div>
    </Tooltip>
  );
};

export const DisplayText = ({ item }) => {
  return (
    <Tooltip title={item.displayText || "-"}>
      <div
        style={{
          fontWeight: 400
        }}
      >
        {item.displayText || "-"}
      </div>
    </Tooltip>
  );
};

export const Site = ({ item }) => {
  return (
    <Tooltip title={item.site || "-"}>
      <div
      >
        {item.site || "-"}
      </div>
    </Tooltip>
  );
};

export const UserId = ({ item }) => {
  return (
    <Tooltip title={item.userId || "-"}>
      <div
      >
        {item.userId || "-"}
      </div>
    </Tooltip>
  );
};

export const App = ({ item }) => {
  return (
    <Tooltip title={item.app || "-"}>
      <div
        style={{
          fontWeight: 400
        }}
      >
        {item.app || "-"}
      </div>
    </Tooltip>
  );
};
export const CidmGroupName = ({ item }) => {
  return (
    <Tooltip title={item.cidmGroupName || "-"}>
      <div
      >
        {item.cidmGroupName !=="null"?item.cidmGroupName:"-"}
      </div>
    </Tooltip>
  );
};


